(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorManagementPolicyFormController', VendorManagementPolicyFormController);

  /* ngInject */
  function VendorManagementPolicyFormController($state, $stateParams, $timeout, $window, Flash, Upload, config, sessionService, vendorManagementPolicyService) {
    const vm = this;

    vm.deleteVendorManagementPolicy = deleteVendorManagementPolicy;
    vm.id = $stateParams.id;
    vm.saveVendorManagementPolicy = saveVendorManagementPolicy;
    vm.sessionService = sessionService;
    vm.vendorManagementPolicy = {};

    $window.bsCustomFileInput.init();

    activate();

    function activate() {
      if (vm.id) {
        getVendorManagementPolicy();
      }
    }

    function deleteVendorManagementPolicy() {
      vendorManagementPolicyService(sessionService.getAuthToken()).destroy({ id: vm.id }, _ => {
        $state.go('application.vms.vendor-management-policies', {});
        Flash.create('success', 'Policy successfully deleted.');
        angular.element('#deleteVendorManagementPolicyModal').modal('hide');
      },
      _ => {
        Flash.create('danger', 'An error occurred with the submission. Please try again later.');
      });
    }

    function getVendorManagementPolicy() {
      vendorManagementPolicyService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.vendorManagementPolicy = response);
    }

    function saveVendorManagementPolicy() {
      if (vm.id) {
        vendorManagementPolicyService(sessionService.getAuthToken()).update({ id: vm.id }, vm.vendorManagementPolicy,
          _ => {
            $state.go('application.vms.vendor-management-policies', {});
            Flash.create('success', 'Policy successfully updated.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          });
      } else {
        let documentUpload = Upload.upload({
          url: `${config.vmsApiEndpoint}/api/vendor_management_policies`,
          method: 'POST',
          data: { vendor_management_policy: vm.vendorManagementPolicy },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        documentUpload.then(_ => {
          $timeout(() => {
            $state.go('application.vms.vendor-management-policies', {});
            Flash.create('success', 'Policy successfully created.');
          });
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      }
    }
  }
})();
